<template>
  <div id="project-one-landing-view">
    <h2>ProjectOneLandingView.vue</h2>
  </div>
</template>

<script>
export default {
  setup() {
    return {};
  },
};
</script>

<style lang="scss" scoped>
#project-one-landing-view {
  background-color: darkorange;
  color: white;
  height: 100%;
}
</style>
